// extracted by mini-css-extract-plugin
export default {"toggleGroup":"styles_toggleGroup__YQq+R"};